<template>
  <BaseModal :visible="showModal" hide-header>
    <UserTypeForm class="pt-4">
      <template v-slot:return>
        <b-button
          :disabled="isFormProcessing"
          variant="white"
          size="md"
          class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
          @click.stop="() => (showModal = false)"
          >Cancel</b-button
        >
      </template>
    </UserTypeForm>
  </BaseModal>
</template>

<script>
import Vue from 'vue'
import { defineComponent, ref, onMounted } from '@vue/composition-api'

import { BaseModal } from '@components/base'

import UserTypeForm from './UserTypeForm.vue'

export default defineComponent({
  name: 'UserTypeModal',
  components: {
    BaseModal,

    UserTypeForm
  },
  setup() {
    const showModal = ref(false)

    const isFormProcessing = ref(false)

    onMounted(() => {
      Vue.prototype.$bus.trackEvent('toggle-modal', ({ key, active }) => {
        if ('user-type' === key) {
          showModal.value = active
        }
      })

      Vue.prototype.$bus.trackEvent('user-type-form-processing', (status) => {
        showModal.value = status

        isFormProcessing.value = status
      })

      Vue.prototype.$bus.trackEvent(
        'error-catched',
        () => (isFormProcessing.value = false)
      )
    })

    return {
      showModal,

      isFormProcessing
    }
  }
})
</script>
